import { get, post, retryAjax } from '../http'
import qs from 'qs'
import {
  LIVEAUTH_URI,
  HOMEMINIURI,
  FIXUP_URL,
  SUBSCRIBE_URI,
  USER_URL,
  LIVE_PALY_URL,
  LIVE_MEETING_URL,
  LIVE_API,
  LIVE_GW_URL,
  homeminiToLiveGw,
  LIVE_INTERFACE_URL,
  WX_API,
  NOTIFY,
  liveGwRetry,
  UPLOAD_URL,
} from '@/utils/http/baseUrl'
import axios from 'axios'

export default {
  /**
   * @method 获取选品小程序的签名信息
   */
  getVspJsApiSign: params =>
    get(`${LIVE_GW_URL}/product/v1/mini/auth/getTxJsApiSign`, params),

  /**
   * @method 获取选品供应商信息
   */
  getVspSupplierInfo: params =>
    post(`${LIVE_GW_URL}/product/v1/mini/auth/getSupplierInfo`, params),

  /**
   * @method 获取直播间Token
   * @param {*} encryptUserId cookie => zbvz_userid
   */
  getLiveToken: params =>
    post(LIVEAUTH_URI + '/api/v1/login/get_wx_token', params),

  /**
   * @method 获取直播间信息
   * @param {*} zbId 直播间Id
   */
  // getSiteInfoById: params =>
  //   get(`${HOMEMINIURI}/api/Generalize/SiteInfoById`, params),
  getSiteInfoById: params =>
    retryAjax({
      gap: 2000,
      retryUrl: `${liveGwRetry}/integral/api/Generalize/SiteInfoById`,
      requestFn: get,
      loading: true,
      maxCount: 2,
    })(`${HOMEMINIURI}/api/Generalize/SiteInfoById`, params, true),

  /**
   * @method 获取封禁直播间信息
   * @param {*} zbId 直播间Id
   */
  getSiteInfoByIdExt: params =>
    get(`${HOMEMINIURI}/api/Generalize/SiteInfoByIdExt`, params),
  /**
   * @method 获取微信签名
   * @param {*} ZBId 直播间Id
   */
  getWeChatSignature: params => {
    if (params) {
      params.fromType = 'drawcenter'
    }
    return get('/liveajax/GetJsSdkParams', params, false)
  },

  /**
   * @method 获取连锁版门店信息
   * @param {*} zbid 直播间Id
   * @param {*} id 直播间Id
   */
  GeneralizeShopBase: params =>
    get(HOMEMINIURI + '/api/ChainStore/GeneralizeShopBase', params),

  /**
   * @method 获取连锁版门店是否使用自己的主页
   * @param {*} liveId 直播间Id
   */
  ischainlevelup: params =>
    get(FIXUP_URL + '/api/v1/wx/indextemplate/ischainlevelup', params),

  // 判断是否关注
  savefocus: params => post('/liveajax/savefocus', qs.stringify(params)),
  /**
   * @method 获取加密地址
   */
  getEncryptUrlInfo: url => post(USER_URL + '/vzapi/EncryptUrlInfo?url=' + url),
  /**
   * @method 获取是否独立公众号和授权情况
   */
  thirdUserBind: params =>
    get(LIVE_PALY_URL + '/api/auth/check_third_user_bind', params),

  // 手机授权方法
  CheckPhoneAuthScene: params =>
    post('/liveajax/CheckPhoneAuthScene', qs.stringify(params)),

  // 优惠券领取
  GetCoupon: params => post('/liveajax/GetCoupon', qs.stringify(params), false),

  // 获取订阅话题模板配置信息
  GetSubscribeConfig: params =>
    get(SUBSCRIBE_URI + '/pushservice/msgPush/GetSubscribeConfig', params),

  // 订阅话题
  SubscribeMsg: params =>
    post(SUBSCRIBE_URI + '/pushservice/msgPush/SubscribeMsg', params),

  // 请求服务器时间
  getCurrentServiceTime: () =>
    axios.get(LIVE_INTERFACE_URL + '/liveplugin/health/gettime'),

  // 获取手机验证码 {"zbid":"","AgentRank":"0","phone":"","Province":0}
  ValidatePlateFormCode: params =>
    post('/liveajax/ValidatePlateFormCode', qs.stringify(params)),
  // 获取用户信息
  get_user_info: params => {
    if (params) {
      params.fromType = 'drawcenter'
    }
    return get(`${FIXUP_URL}/api/v1/wx/indextemplate/get_user_info`, params)
  },

  // 获取用户权限
  getRole: params => post(`${LIVEAUTH_URI}/api/v1/permission/get_role`, params),

  // 获取营销配置
  get_config: params => post(`/marketing/wx/v1/public/config`, params),

  // 获取用户权限
  // saveuserinfo: params => post(`/liveajax/saveuserinfo`, params)

  // 获取直播间zbvd
  get_zbvd_info: params =>
    get(`${LIVE_PALY_URL}/api/topic/topic_config`, params),

  /**
   * @method 判断用户是否有支付openId
   */
  getUserHasPayOpenId: params =>
    get(USER_URL + '/vzapi/UserHasPayOpenId', params, false),

  // 根据用户id检查用户会员等级信息
  getMemberInfo: params =>
    retryAjax({
      retryUrl: `${homeminiToLiveGw()}/api/MemberLevel/getMemberInfo`,
      requestFn: get,
      maxCount: 2,
    })(`${homeminiToLiveGw()}/api/MemberLevel/getMemberInfo`, params, false),
  // 根据会议id获取专题页信息
  getByMeetingId: data =>
    get(
      `${LIVE_MEETING_URL}/marketing/live/v1/aggspread_page/get_by_meeting_id`,
      data
    ),
  // 获取定制直播间
  customConfigApi: zbid =>
    get(LIVE_PALY_URL + '/api/live/customconfig?zbid=' + zbid),
  // 获取已经授权的手机
  getCheckPhoneNum: params =>
    post('/liveajax/CheckPhoneAuthSceneNonLive', qs.stringify(params)),
  // 通过接口发送消息
  sendChatMsg: data =>
    post(`${LIVE_PALY_URL}/api/topic/topic_send_chatmsg`, data),

  // 获取注册验证码
  getPhoneCode: data =>
    post(`${LIVE_API}/VZlive/ValidatePhoneCodeV2`, qs.stringify(data)),

  // 提交注册直播间
  CreateLive: data =>
    post(`${LIVE_API}/livesapi/CreateLive`, qs.stringify(data)),
  // websocket
  wwsUrl: data => get(`${LIVE_GW_URL}/imglive/v1/common/wwsUrl`, data),
  // 日志上报
  postLog: data =>
    post(`${FIXUP_URL}/api/v1/wx/log/collect`, {
      logInfo: JSON.stringify(data),
    }),
  // 提交注册直播间
  getTopicInfo: data =>
    get(`${LIVE_GW_URL}/imglive/v1/common/topic/detail_info`, data),
  // 判断是否是灰度直播间
  checkGrayLive: data =>
    get(`${LIVE_GW_URL}/marketing/api/MemberLevel/isUseNewService`, data),

  // 检查用户是否跨直播间
  checkAcrossLive: data =>
    get(`${LIVE_GW_URL}/health/v1/h5/liveMerge/checkAcrossLive`, data),

  // 获取用户跨直播间信息
  getAcrossLiveInfo: data =>
    get(`${LIVE_GW_URL}/health/v1/h5/liveMerge/getAcrossLiveInfo`, data),

  // 获取话题信息
  getTopicDetail: data => get(`${FIXUP_URL}/api/v1/topic/topic_detail`, data),
  // 获取用户跨直播间信息
  friendAuth: data => post(`${NOTIFY}/v1/supper/gwRobot/friendAuth`, data),
  // 获取直播间列表
  getLiveList: data =>
    post(
      `${LIVE_GW_URL}/product/v1/admin/supplierRelationZb/getUserSiteList`,
      data
    ),
  // 添加直播间
  setSupplierRelationZb: data =>
    post(
      `${LIVE_GW_URL}/product/v1/admin/supplierRelationZb/setSupplierRelationZb`,
      data
    ),
  // 添加直播间
  getSupplierInfo: data =>
    post(
      `${LIVE_GW_URL}/product/v1/admin/supplierRelationZb/getSupplierInfo`,
      data
    ),
  // 检查二维码是否失效
  getRecruitValidity: ({ validityKey, zbId }) =>
    post(
      `${LIVE_GW_URL}/health/v1/h5/agent/getRecruitValidity?validityKey=${validityKey}&&zbId=${zbId}`
    ),
}

// 查询用户所拥有的权限
export const getCheckPhoneNum = data =>
  retryAjax({
    retryUrl: `/liveajax/CheckPhoneAuthSceneNonLive`,
    requestFn: post,
    maxCount: 2,
  })(`/liveajax/CheckPhoneAuthSceneNonLive`, data, false)

export const getMyManageRoomList = data =>
  post(`${WX_API}/livesapi/MyManageRoomList`, qs.stringify(data))

export const getAttributes = data =>
  retryAjax({
    retryUrl: `${LIVE_INTERFACE_URL}/custom/v1/topic/getAttributes`,
    requestFn: post,
    maxCount: 2,
  })(`${LIVE_INTERFACE_URL}/custom/v1/topic/getAttributes`, data, false)

export const getInviteMiniProgramUrl = data =>
  post(`${LIVE_GW_URL}/train/v1/cus/invite/code/get_mini_program_url`, data)

export const getAreaList = data =>
  post(`${LIVE_GW_URL}/generic/v1/homepage/personal/getCommonAreaList`, data)

// 获取用户授权配置
export const getAuthConfig = params => {
  return get(`${LIVE_PALY_URL}/api/live/education/authConfig`, params, false, {
    zhibo: false,
  })
}

// 获取用户授权配置开关
export const getPhoneAuthScene = params => {
  return get(`/liveajax/GetUserPhoneAuthScene`, params, false, {
    zhibo: true,
  })
}

// 获取短链接
export const getShortLink = data =>
  get(`${FIXUP_URL}/api/v1/ShortLink/user/get_short_link`, data)

// 获取预估流量
export const getFlowEstimation = data =>
  post(`${LIVE_GW_URL}/datalive/v1/common/flow/flowEstimation`, data)
